/**
 * Get all packages
 */
export function allPackages(state) {
  return state.packages;
}

/**
 * Get pagination info
 */
export function paginationInfo(state) {
  return state.pagination;
}

/**
 * Get current filters
 */
export function currentFilters(state) {
  return state.filters;
}

/**
 * Get selected package keys
 */
export function selectedPackageKeys(state) {
  return state.selectedKeys;
}

/**
 * Get selected packages (full objects)
 */
export function selectedPackages(state) {
  return state.packages.filter((pkg) =>
    state.selectedKeys.includes(`${pkg.license_id}:${pkg.tag}`)
  );
}

/**
 * Check if a package is selected
 */
export function isPackageSelected(state) {
  return (licenseId, tag) => {
    return state.selectedKeys.includes(`${licenseId}:${tag}`);
  };
}

/**
 * Get count of selected packages
 */
export function selectedCount(state) {
  return state.selectedKeys.length;
}

/**
 * Check if any packages are selected
 */
export function hasSelection(state) {
  return state.selectedKeys.length > 0;
}

/**
 * Check if all selected packages are from the same license (for split operation)
 */
export function allSelectedSameLicense(state, getters) {
  const selected = getters.selectedPackages;
  if (selected.length === 0) return true;
  const firstLicenseId = selected[0].license_id;
  return selected.every((pkg) => pkg.license_id === firstLicenseId);
}

/**
 * Get the license ID if all selected packages are from the same license
 */
export function selectedLicenseId(state, getters) {
  const selected = getters.selectedPackages;
  if (selected.length === 0) return null;
  if (!getters.allSelectedSameLicense) return null;
  return selected[0].license_id;
}

/**
 * Check if store is loading
 */
export function isLoading(state) {
  return state.loading;
}

/**
 * Check if an action is in progress
 */
export function isActionLoading(state) {
  return state.actionLoading;
}

/**
 * Check if any selected packages are excluded
 */
export function hasExcludedSelected(state, getters) {
  return getters.selectedPackages.some((pkg) => pkg.is_excluded);
}

/**
 * Check if any selected packages are not excluded
 */
export function hasIncludedSelected(state, getters) {
  return getters.selectedPackages.some((pkg) => !pkg.is_excluded);
}

/**
 * Check if any selected packages have custom mappings
 */
export function hasCustomMappedSelected(state, getters) {
  return getters.selectedPackages.some((pkg) => pkg.custom_product_id !== null);
}
